import { FC } from "react";
import Markdown from "react-markdown";

import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";

import { insertDomain } from "@/service/ApplicationQueries";

interface IMarkdowContentRenderer {
  className?: string;
  content: string | undefined;
  rehypePlugins?: Markdown.PluggableList | undefined;
  insertDomainOptions?: { insertIntoHtmlElement: boolean };
  linkTarget?: string;
  OnClickImage?: () => void;
}

export const SATOSContentRender: FC<IMarkdowContentRenderer> = (props) => {
  const customSchema = {
    ...defaultSchema,
    tagNames: [...(defaultSchema.tagNames || []), "u"], // Add <u> tag
  };

  const plugins = props.rehypePlugins
    ? props.rehypePlugins
    : [rehypeRaw, [rehypeSanitize, customSchema]];

  const options = props.insertDomainOptions ?? {
    insertIntoHtmlElement: true,
    markdown: true,
  };

  const linkTarget = props.linkTarget ? props.linkTarget : "_blank";

  if (!props.content) {
    return <></>;
  }

  return (
    <Markdown
      className={props.className}
      rehypePlugins={plugins}
      linkTarget={linkTarget}
    >
      {insertDomain(props.content, options)}
    </Markdown>
  );
};
